<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <live-chat></live-chat>
  </div>
</template>

<script>
import LiveChat from './components/live-chat'

export default {
  name: 'App',
  components: {
    LiveChat
  },
  provide () {
    return {
      $_reload: this.$_reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (val, oldVal) {
        if (oldVal && oldVal.query.sp_name) {
          this.$router.replace({
            path: val.path,
            query: {
              ...val.query,
              sp_name: oldVal.query.sp_name
            }
          })
        }
      }
    }
  },
  methods: {
    $_reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
 #app {
   height: 100%;
   width: 100%;
 }
@import './style/index.scss';
// 投必得
@import url('//at.alicdn.com/t/font_1812983_6u4lzpzwm04.css');
</style>



// WEBPACK FOOTER //
// src/App.vue